import React, { ReactNode } from "react";
import { CardMedia as MuiCardMedia } from "@mui/material";

interface CardMediaProps {
  imgUrl: string;
  imgTitle?: string;
  className?: string;
}

export const CardMedia: React.FC<CardMediaProps> = ({
  imgUrl,
  imgTitle,
  className,
}: CardMediaProps) => {
  return (
    <MuiCardMedia
      image={imgUrl}
      title={imgTitle}
      className={`card__media ${className}`}
    />
  );
};
